module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-number"
  }, [_c('a', {
    attrs: {
      "id": "page-3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/toc#toc-chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('span', {
    attrs: {
      "href": "#/toc#toc-chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Door Closes, Another Opens")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Later, in circumstances that Sharon Li would certainly have frowned upon, the entire balance of reality is about to be pushed off the bungee.")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_vm._v("Soft cloth drags on carpet.")]), _vm._v(" "), _c('p', [_vm._v("A door closes in the night.")]), _vm._v(" "), _c('p', [_vm._v("Flicker of shadow across a door.")]), _vm._v(" "), _c('p', [_vm._v("Sound of falling.")]), _vm._v(" "), _c('p', [_vm._v("She says, “They’ll find you they’ll find you you have to get out now!”")]), _vm._v(" "), _c('p', [_vm._v("Her voice is a gabble of forced breath, sandpaper in the throat, glass in the lungs.")]), _vm._v(" "), _c('p', [_vm._v("A finger of wind commanding silence.")]), _vm._v(" "), _c('p', [_vm._v("“Oh God.”")]), _vm._v(" "), _c('p', [_vm._v("A brush of something soft against rapidly cooling skin, a whisper of sound that has no words, nor has ever felt the need.")]), _vm._v(" "), _c('p', [_vm._v("“Let me live.”")]), _vm._v(" "), _c('p', [_vm._v("Paper stirs across the floor.")]), _vm._v(" "), _c('p', [_vm._v("Something…")]), _vm._v(" "), _c('p', [_vm._v("… changes.")]), _vm._v(" "), _c('p', [_vm._v("She says, “No. That isn’t what I—”")]), _vm._v(" "), _c('p', [_vm._v("And she dies.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eac3a48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 72
// module chunks = 0